import PropTypes from "prop-types"
import React, { useState } from "react"
import styles from "./thumbnail.module.scss"
import classNames from "classnames"
import Waveform from "../../../media-output/audiowave"
import { MdPhoto, MdPictureAsPdf, MdHeadset,MdVideocam } from "react-icons/md"
import { GiOpenBook } from "react-icons/gi"
import { IoMdDocument } from "react-icons/io"
import { useEffect } from "react"
import { set } from "lodash"
import util from "../../../../services/util"

const Thumbnail = (
  { data, 
    featuredPhotos, 
    showPlaceHolder, 
    standardCard, 
    mediaPlayingId, 
    fnSetMediaPlayingId, 
    mediaPlaying, 
    fnSetMediaPlaying, 
    audioFile }) => {

  const shouldDisplayPlaceholder = ignorePending => {
    let ref = data && data.sourceFile ? data.sourceFile : data
    return (
      (ref.thumbnailStatus &&
      ((ref.thumbnailStatus === "PENDING" && !ignorePending) ||
        ref.thumbnailStatus === "EMPTY")) ||
      ref.thumbnailUrl === ''
    )
  }

  const [featuredPhotoUrl, setFeaturedPhotoUrl] = useState(null);

  useEffect(() => {
    if(featuredPhotos) {

      if (!data.webViewUrl) {
        console.warn("No webViewUrl found on item.");
        return;
      }
  
      var imageUrl = makeUrl();
      const updatedUrl = imageUrl.replace("/webview/", "/download/");

      console.log("Featured photo URL set to: ", updatedUrl);

      setFeaturedPhotoUrl(updatedUrl);
    }
  }, [])

  const makeUrl = () => {
    let baseUrl = ''
    if (data.webViewUrl.includes('http://')) {
      baseUrl = util.baseUrl()
    }
    else {
      baseUrl = util.baseUrl().replace('http://', '')
    }

    if(data.sourceFile.mime === 'image/tiff') {
      return data.webViewUrl;
    }

    baseUrl = baseUrl + 'api/media/download/' + data.sourceFile.id + '/' + data.sourceFile.name;
    return baseUrl;
    //return webViewUrl ? `${util.baseUrl()}${webViewUrl.replace(baseUrl, '').toLowerCase().replace('http://appst-fedia-pq7u6wd4330r-317694051.ca-central-1.elb.amazonaws.com/','')}` : webViewUrl;
  }

  var type = data.type ? data.type : data.mediaType
  switch (type) {
    case "Photo":
      // TODO this is always pending on upload even though it seems to be available? "true" can be false if this was working
      if (shouldDisplayPlaceholder(true)) {
        return (
          <div
            className={classNames(
              styles?.icons,
              styles?.thumbnailIconPhoto,
              "thumbnail-icon-photo"
            )}
          ></div>
        )
      } else {
        if (!standardCard) {
          if(featuredPhotos) {
            return <img src={featuredPhotoUrl} alt={data.title} />
          }
          return <img src={data.thumbnailUrl} alt={data.title} />
        }
        else {
          if(featuredPhotos) {
            return (
              <div className={styles?.container}>
                <img src={featuredPhotoUrl} alt={data.title} />
                <div className={styles?.overlay}>
                  <div className={styles?.playIcon}>
                    <MdPhoto />
                  </div>
                </div>              
              </div>            
            )
          }
          return (
            <div className={styles?.container}>
              <img src={data.thumbnailUrl} alt={data.title} />
              <div className={styles?.overlay}>
                <div className={styles?.playIcon}>
                  <MdPhoto />
                </div>
              </div>              
            </div>            
          )

        }
      }
    case "Video":
      if (shouldDisplayPlaceholder(true)) {
        return (
          <div
            className={classNames(
              styles?.icons,
              styles?.thumbnailIconVideo,
              "thumbnail-icon-video"
            )}
          ></div>
        )
      } else {
          if (!standardCard) {
            return <img src={data.thumbnailUrl} alt={data.title} />
          }
          else {            
          return (
            <div className={styles?.container}>
              <img src={data.thumbnailUrl} alt={data.title} />
              <div className={styles?.overlay}>
                <div className={styles?.playIcon}>
                  <MdVideocam />
                </div>
              </div>
            </div>                  
          )
        }  
      }
    case "Audio":
      if (shouldDisplayPlaceholder(false)) {
        return (
          <div
            className={classNames(
              styles?.thumbnailIconAudio,
              styles?.icons,
              "thumbnail-icon-audio"
            )}
          ></div>
        )
      } else {
        if (!standardCard) {
          return (
            <div
              className={classNames(
                styles?.thumbnailIconAudio,
                styles?.icons,
                "thumbnail-icon-audio"
              )}
            ></div>
          )
        }
        else {
          return (
            <div className={styles?.container}>
              <Waveform 
                data={data} 
                mediaPlayingId={mediaPlayingId} 
                fnSetMediaPlayingId={fnSetMediaPlayingId} 
                mediaPlaying={mediaPlaying} 
                fnSetMediaPlaying={fnSetMediaPlaying}
              />
              <div className={styles?.overlay}>
                <div className={styles?.playIcon}>
                  <MdHeadset />
                </div>
              </div>
            </div>  
          )
        }  
      }
    case "Document":
      if (shouldDisplayPlaceholder(true)) {
        return (
          <div
            className={classNames(
              styles?.icons,
              styles?.thumbnailIconPdf,
              "thumbnail-icon-pdf"
            )}
          ></div>
        )
      } else {
        if (!standardCard) {
          return <img src={data.thumbnailUrl} alt={data.title} />
        }
        else {
          return (
            <div className={styles?.container}>
              <img src={data.thumbnailUrl} alt={data.title} />
              <div className={styles?.overlay}>
                <div className={styles?.playIcon}>
                  <IoMdDocument />
                </div>
              </div>
            </div>                  
          )
        }  
      }

    case "Archive":
      return (
        <div
          className={classNames(
            styles?.thumbnailIconFile,
            styles?.icons,
            "thumbnail-icon-file"
          )}
        ></div>
      )
    case "Story":
      if (shouldDisplayPlaceholder(false)) {
        return (
          <div
            className={classNames(
              styles?.icons,
              styles?.thumbnailIconStory,
              "thumbnail-icon-story"
            )}
          ></div>
        )
      } else {
        if (!standardCard) {
          return <img src={data.thumbnailUrl} alt={data.title} />
        }
        else {
          return (
            <div className={styles?.container}>
              <img src={data.thumbnailUrl} alt={data.title} />
              <div className={styles?.overlay}>
                <div className={styles?.playIcon}>
                  <GiOpenBook />
                </div>
              </div>
            </div> 
          )
        }  
      }
    default:
      return <div>Unknown content type</div>
  }
}

Thumbnail.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Thumbnail
